import {white, black, grey, primary, secondary, info, success, warning, danger} from './colors';

export default {
    common: {
        black,
        white,
        neutral: '#E4E7EB',
        muted: '#9EA0A4',
    },
    background: {
        default: grey[100],
        paper: white,
        dark: '#172B4D',
    },
    primary,
    secondary,
    info,
    success,
    warning,
    error: danger,
    grey,
    text: {
        primary: grey[900],
        secondary: grey[600],
        disabled: grey[400],
    },
    divider: grey[200],
    border: grey[200],
    action: {
        active: grey[600],
        hover: grey[100],
        selected: grey[200],
        disabled: grey[300],
        disabledBackground: grey[200],
        focus: grey[200],
    },
};
